import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class FilterSidebar extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    visible: PropTypes.bool
  };

  render() {
    const sidebarClass = classNames({
      "filter-sidebar": true,
      "hidden-xs": true,
      "hidden-sm": true,
      collapsed: !this.props.visible
    });

    return (
      <div className={sidebarClass}>
        {this.props.children}
      </div>
    );
  }
}
